import { Box, Icon, Text } from "@salestrak/ui";
import { MEDIA_TILE_SIZE } from "#app/components/media/media-tiles";
import { fileIconName, fileTypeLabel } from "#app/lib/media-kind";
import type { Omittable } from "@salestrak/ui";

/**
 * Tile-sized card for a document attachment (office docs, csv, txt) — there's
 * no client-renderable preview, so we show a file icon, the type label, and the
 * filename. Clicking opens/downloads the file (the content route sets the
 * download disposition by type).
 */
export function MediaFileCard({
  contentType,
  fileName,
  size = MEDIA_TILE_SIZE,
  onClick,
}: Omittable<{
  contentType: string;
  fileName?: string | null;
  size?: number;
  onClick?: () => void;
}>) {
  return (
    <Box
      as="button"
      width={size}
      height={size}
      rounded="md"
      border
      surface="card"
      align="center"
      justify="center"
      gap="2xs"
      padding="xs"
      hoverBackground
      onClick={onClick}
      aria-label={fileName ? `Open ${fileName}` : "Open file"}
    >
      <Icon name={fileIconName(contentType)} size="md" color="muted" />
      <Text size="2xs" weight="medium" variant="muted">
        {fileTypeLabel(contentType, fileName)}
      </Text>
      {fileName ? (
        <Text size="2xs" variant="muted" truncate={1} align="center">
          {fileName}
        </Text>
      ) : null}
    </Box>
  );
}
